import { useEffect, useState } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Marquee } from "./components/Marquee";
import { Story } from "./components/Story";
import { MenuSection } from "./components/MenuSection";
import { Experience } from "./components/Experience";
import { Gallery } from "./components/Gallery";
import { Events } from "./components/Events";
import { Reservation } from "./components/Reservation";
import { ReservationModal } from "./components/ReservationModal";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";

function App() {
  const [reservationOpen, setReservationOpen] = useState(false);
  const openReservation = () => setReservationOpen(true);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#141210] text-[#f7f4ef]" data-testid="app-root">
      <Navbar onReserve={openReservation} />
      <main>
        <Hero onReserve={openReservation} />
        <Marquee />
        <Story />
        <MenuSection />
        <Experience />
        <Gallery />
        <Events />
        <Reservation onReserve={openReservation} />
        <Contact />
      </main>
      <Footer />
      <ReservationModal open={reservationOpen} onClose={() => setReservationOpen(false)} />
      <Toaster
        theme="dark"
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#28231f",
            border: "1px solid rgba(212, 175, 55, 0.35)",
            color: "#f7f4ef",
          },
        }}
      />
    </div>
  );
}

export default App;
